import { Box, Link, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC } from 'react';
import { PUBLIC_DOCUMENTS_PATHS } from 'src/lib/constants/publicDocumentPaths';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { enumT } from '../../../../utils/helper';
import SummaryLine from '../../../ui-component/form-component/abschluss-page/SummaryLine';
import CreateForm from '../../../ui-component/form-component/create-form/CreateForm';

// import Schema
import HochschuleSchema from 'src/lib/paths/hochschule_FULL_Paths.json';
import OrgaSchema from 'src/lib/paths/organisation_FULL_Paths.json';
import PersonSchema from 'src/lib/paths/person_FULL_Paths.json';
import UserSchema from 'src/lib/paths/user_Paths.json';
const PP = PersonSchema.attributes;
const OP = OrgaSchema.attributes;
const HS_P = HochschuleSchema.attributes;
const UP = UserSchema.attributes;

const AbschlussRegistrierung: FC<{
	formValue: any;
	updateFunction: (_key: string, _value: any) => void;
	datenschutzZustimmungError: any;
	abteilungsDaten: any;
	personDaten: any;
	loginDaten: any;
	alleHochschulen: any;
}> = ({ formValue, updateFunction, datenschutzZustimmungError, abteilungsDaten, personDaten, loginDaten, alleHochschulen }) => {
	const selectedHochschuleId = get(abteilungsDaten, OP.Hochschule.path);
	const selectedHochschule = alleHochschulen.find((hochschule: any) => hochschule.id === selectedHochschuleId);
	const hochschulname = get(selectedHochschule, HS_P.Geschaeftsbezogene_Daten_angezeigter_Name.path, '-');

	return (
		<>
			<ApplicationHeading title='Bitte überprüfen Sie Ihre Angaben:' />

			{/* Summary of Personendaten */}
			<Box sx={{ mt: '2rem' }}>
				<Typography variant='h6'>Ihr Profil</Typography>
				<SummaryLine
					label='Anrede'
					value={enumT(get(personDaten, PP.Personenbezogene_Daten_Anrede.path, '-'))}
					showErrorMessagePlaceholder={false}
				/>
				<SummaryLine label='Titel' value={get(personDaten, PP.Personenbezogene_Daten_Titel.path, '-')} showErrorMessagePlaceholder={false} />
				<SummaryLine label='Vorname' value={get(personDaten, PP.Personenbezogene_Daten_Vorname.path, '')} showErrorMessagePlaceholder={false} />
				<SummaryLine label='Nachname' value={get(personDaten, PP.Personenbezogene_Daten_Nachname.path, '')} showErrorMessagePlaceholder={false} />
				<SummaryLine
					label='E-Mail - Die Passwortvergabe wird an diese Adresse gesendet'
					value={get(personDaten, PP.Kontaktdaten_E_Mail.path, '')}
					showErrorMessagePlaceholder={false}
				/>
				<SummaryLine label='Telefon' value={get(personDaten, PP.Kontaktdaten_Telefon.path, '')} showErrorMessagePlaceholder={false} />
			</Box>

			{/* Summary of Abteilungsdaten */}
			<Box sx={{ mt: '2rem' }}>
				<Typography variant='h6'>Organisationsprofil</Typography>
				<SummaryLine label='Hochschule' value={hochschulname} showErrorMessagePlaceholder={false} />
				<SummaryLine
					label='Fachbereich'
					value={get(abteilungsDaten, OP.Geschaeftsbezogene_Daten_Name_Der_Organisation.path)}
					showErrorMessagePlaceholder={false}
				/>
				<SummaryLine
					label='Straße und Hausnummer'
					value={get(abteilungsDaten, OP.Adressdaten_Strasse_Und_Hausnummer.path)}
					showErrorMessagePlaceholder={false}
				/>
				<SummaryLine label='Adresszusatz' value={get(abteilungsDaten, OP.Adressdaten_Adresszusatz.path)} showErrorMessagePlaceholder={false} />
				<SummaryLine
					label='Postleitzahl, Ort'
					value={get(abteilungsDaten, OP.Adressdaten_PLZ.path, '-') + ' ' + get(abteilungsDaten, OP.Adressdaten_Ort.path, '-')}
					showErrorMessagePlaceholder={false}
				/>
			</Box>

			{/**
			 * Ihre Zugangsdaten
			 */}
			<Box sx={{ mt: '2rem', mb: '2rem' }}>
				<Typography variant='h6'>Ihre Zugangsdaten</Typography>
				<SummaryLine label='Benutzername' value={get(loginDaten, UP.username.path)} showErrorMessagePlaceholder={false} />
				<SummaryLine
					label='E-Mail - Die Passwortvergabe wird an diese Adresse gesendet'
					value={get(personDaten, PP.Kontaktdaten_E_Mail.path, '')}
					showErrorMessagePlaceholder={false}
				/>
			</Box>

			{/* Zustimmung to Terms and Conditions */}
			<Typography variant='h6' sx={{ fontWeight: 600, mt: '2rem' }}>
				Datenschutzhinweise zum digitalen Antragsportal
			</Typography>
			<Typography>
				Informatioinen zur Datenverarbeitung im Rahmen der Registrierung und Portalnutzung finden Sie in den{' '}
				<Link target='_blank' href={PUBLIC_DOCUMENTS_PATHS.datenschutz.datenschutzHinweise.path}>
					Datenschutzhinweisen
				</Link>
				{'. '}
			</Typography>

			<CreateForm
				formValues={formValue}
				formStruc={formStrucDatenschutz()}
				updateFormValuesFunc={updateFunction}
				formErrors={datenschutzZustimmungError}
			/>
		</>
	);
};

export default AbschlussRegistrierung;

const formStrucDatenschutz = () => {
	return [
		{
			fields: [
				{
					path: 'zustimmung',
					type: 'boolean',
					label: `Ich habe die Datenschutzhinweise gelesen und bin über die Datenverarbeitung im Antragsportal informiert.`,
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
};
